<template>
  <div class="sidepane__container">
    <keep-alive>
      <component
        :is="currentComponent"
        @toggle:sidepane="toggleSidepane"
      />
    </keep-alive>
  </div>
</template>

<script>
import { computed, ref } from 'vue';
import { emitter } from '@/common/utils/emitter';
import SidePaneSearch from './SidePaneSearch.vue';
import SitePaneSiteInfo from './SidePaneSiteInfo.vue';
export default {
  name: 'Sidepane',
  components: {
    SidePaneSearch,
    SitePaneSiteInfo,
  },
  setup() {
    const type = ref('list');
    const currentComponent = computed(() => (type.value === 'list' ? SidePaneSearch : SitePaneSiteInfo));
    const toggleSidepane = () => {
      type.value = type.value === 'list' ? 'info' : 'list';
    };

    emitter.on('clicked:info', () => {
      toggleSidepane();
    });

    return { type, currentComponent, toggleSidepane };
  },
};
</script>
